import React from 'react';
import { connect } from 'react-redux';
import { handleFormChanged } from '@/store/allaround.store.js';
import { alterPort, alterPortField } from '../store/ports.store.js';
import { dateTimePickerFormat, timePickerFormat } from '../../../../util/util.jsx';
import { FormTextField } from '../elements/FormTextField';
import {
  Button,
  Col,
  Row,
  Glyphicon,
  Modal,
} from 'react-bootstrap';
import {
  FormControl,
  DateTimePicker2 as DateTimePicker,
} from '../../../form/FormControls.jsx';
import Label from '@/component/form/Label.jsx';
import RefPicker from '../../../dict/simple/select/DictPicker.jsx';
import FancyInput from '@/component/form/numinput/index.jsx';
import CurrencyInput from '@/component/form/currencyinput/index.jsx';
import FromToDatePickers from '../../../form/FromToDateHorizontalPickers';
import { Audit } from '../audit/Audit.jsx';
import { vesselLoadingStatus, vesselDischargingStatus } from '../../../dict/Enums.js';
import AvailableSince, { VERSIONS } from '@/util/version';
import RoleConfigFilter from '@/component/auth/RoleConfigFilter.jsx';

import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
import trash from '../../../../../style/trash.png';
import loadport from '../../../../../style/loadportblue.png';
import unloadport from '../../../../../style/unloadportblue.png';
import audit from '../../../../../style/audit.png';
moment.locale('en');
momentLocalizer();

class PortEditClass extends React.Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.yesButton = this.yesButton.bind(this);
    this.parseTime = this.parseTime.bind(this);

    this.state = {
      CQD: props.data && props.data.get('dispatchType') == 'CQD',
      showModal: false,
      hidden: false,
    };
  }

  openModal() {
    this.setState({ showModal: true });
  }
  closeModal() {
    this.setState({ showModal: false });
  }
  yesButton() {
    this.props.alterPortField('hidden', !this.state.hidden);
    this.setState({ showModal: false, hidden: !this.state.hidden });
    this.props.handleFormChanged();
  }

  parseTime(str) {
    let etc = moment(this.props.data.get('etc')).format(dateTimePickerFormat);
    if (etc == 'Invalid date') {
      etc = moment().format(dateTimePickerFormat);
    }
    return moment(`${etc} ${str}`).toDate();
  }

  render() {
    let loadingStatus = vesselLoadingStatus.toOrderedMap();
    if (this.props.idx != 0) {
      loadingStatus = loadingStatus.delete('PREV_CARGO_VOYAGE');
    }
    return (<div
      id={`${this.props.portType}_${this.props.formId}`}
      style={this.state.hidden ? { display: 'none' } : {}}
    >
      <Modal bsSize="small" show={this.state.showModal} onHide={this.closeModal} >
        <Modal.Body>
          Are you sure you want to {this.state.hidden ? 'restore' : 'delete'} port?
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="danger" onClick={this.yesButton}>Yes</Button>
          <Button onClick={this.closeModal}>No</Button>
        </Modal.Footer>
      </Modal>
      <Row>
        <Col xs={12} style={{ paddingLeft: 5 }}>
          <img
            src={this.props.portType == 'vesselLoadingPorts' ? loadport : unloadport}
            role={'presentation'} className={'small-transport-port-icon'}
          />
        </Col>
        <Col md={12}>
          <Label
            label={this.props.portType == 'vesselLoadingPorts' ? 'Loading at' : 'Discharge at'}
            vertical
            sm={12}
            style={{ padding: '0px 5px 0px 5px' }}
          >
            <RefPicker
              dict="port" name="place"
              onChangeFunc={val =>
                this.props.alterPortField('place',
                  val !== undefined && val !== null ? val.value : val)}
              defaultValue={this.props.data.get('place')}
              disabled={this.props.disabled}
            />
          </Label>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Label label="Status" vertical sm={12} style={{ padding: '0px 5px 0px 5px' }}>
            <FormControl
              componentClass="select"
              placeholder="Select..."
              name="status"
              onChange={(ev) => this.props.alterPortField('status', ev.target.value)}
              defaultValue={this.props.data.get('status')}
              disabled={this.props.disabled}
            >
              {(this.props.portType == 'vesselLoadingPorts'
                ? loadingStatus
                : vesselDischargingStatus)
                .entrySeq()
                .map((vals) =>
                  <option key={vals[0]} value={vals[0]}>{vals[1]}</option>
                )
              }
            </FormControl>
          </Label>
        </Col>
      </Row>
      {this.props.portType == 'vesselLoadingPorts'
        ?
        <FromToDatePickers
          vertical
          labelSm={12}
          labelStyle={{ padding: '0px 5px 0px 5px' }}
          labelFrom="Laycan date" labelTo="&nbsp;"
          nameFrom="laycanStart" nameTo="laycanEnd"
          onChangeFrom={val => {
            this.props.alterPortField('laycanStart',
              val ? moment(val).format('DD MMM YYYY') : undefined);
            this.props.handleFormChanged();
          }}
          onChangeTo={val => {
            this.props.alterPortField('laycanEnd',
              val ? moment(val).format('DD MMM YYYY') : undefined);
            this.props.handleFormChanged();
          }}
          defaultValueFrom={this.props.data.get('laycanStart')
            ? new Date(this.props.data.get('laycanStart'))
            : undefined}
          defaultValueTo={this.props.data.get('laycanEnd')
            ? new Date(this.props.data.get('laycanEnd'))
            : undefined}
          disabled={this.props.disabled}
        />
        :
        <Row style={{ height: '76px' }} />
      }
      <Row style={{ display: 'flex', alignItems: 'flex-end' }}>
        <Col md={6}>
          <Label label="ETA" vertical sm={12} style={{ padding: '0px 5px 0px 5px' }}>
            <DateTimePicker
              format={dateTimePickerFormat}
              time={false}
              name="eta"
              onChange={val => {
                this.props.alterPortField('eta',
                  val ? moment(val).format('DD MMM YYYY') : undefined);
                this.props.handleFormChanged();
              }}
              defaultValue={this.props.data.get('eta')
                ? new Date(this.props.data.get('eta'))
                : undefined}
              disabled={this.props.disabled}
            />
          </Label>
        </Col>
        <Col md={6}>
          <Label
            label={this.props.portType == 'vesselLoadingPorts'
              ? 'Commencement of Loading'
              : 'Commencement of Discharge'}
            vertical
            sm={12}
            style={{ padding: '0px 5px 0px 5px' }}
          >
            <Col md={6} style={{ padding: '0 10px 0 0' }}>
              <DateTimePicker
                format={dateTimePickerFormat}
                time={false}
                name="commencement"
                onChange={val => {
                  this.props.alterPortField('commencement',
                    val ? moment(val).format('DD MMM YYYY') : undefined);
                  this.props.handleFormChanged();
                }}
                defaultValue={this.props.data.get('commencement')
                  ? new Date(this.props.data.get('commencement'))
                  : undefined}
                disabled={this.props.disabled}
              />
            </Col>
            <Col md={6} style={{ padding: 0 }}>
              <DateTimePicker
                step={15}
                timeFormat={timePickerFormat}
                format={timePickerFormat}
                date={false}
                time
                parse={this.parseTime}
                name="commencementTime"
                onChange={val => this.props.alterPortField('commencementTime',
                  val ? moment(val).format(`${dateTimePickerFormat} ${timePickerFormat}`)
                    : undefined)}
                defaultValue={this.props.data.get('commencementTime')
                  ? new Date(this.props.data.get('commencementTime'))
                  : undefined}
                disabled={this.props.disabled}
              />
            </Col>
          </Label>
        </Col>
      </Row>
      {/* Discharge/loading at buttons section */}
      <Row style={{ paddingLeft: '5px' }}>
        <Col md={6}>
          <Label
            label={this.props.portType == 'vesselLoadingPorts'
              ? 'Loading terms'
              : 'Discharge terms'}
            vertical
            sm={12}
            style={{ padding: '0px 7px 0px 0px' }}
          >
            <Button
              onClick={() => {
                this.setState({ CQD: false });
                this.props.alterPortField('dispatchType', 'RATE');
              }}
              bsStyle={this.state.CQD ? 'default' : 'primary'}
              style={{ width: '50% ', height: '36px' }}
              disabled={this.props.disabled}
              className={'button-pair-left'}
              id="portRate"
            >
              Rate
            </Button>
            <Button
              onClick={() => {
                this.setState({ CQD: true });
                this.props.alterPortField('dispatchType', 'CQD');
              }}
              bsStyle={this.state.CQD ? 'primary' : 'default'}
              style={{ width: '50% ', height: '36px' }}
              disabled={this.props.disabled}
              className={'button-pair-right'}
              id="portCQD"
            >
              CQD
            </Button>
          </Label>
        </Col>
        {!this.state.CQD ?
          <Col md={6}>
            <Label label="&nbsp;" vertical sm={12} style={{ padding: '0px 14px 0px 14px' }}>
              <Row>
                <Col sm={3} style={{ padding: '0px 5px 0px 5px' }}>
                  <FancyInput
                    className="form-control"
                    thousand
                    fraction={0}
                    positive
                    negative={false}
                    type="number"
                    id="rate" name="rate"
                    onChange={(ev, val) => this.props.alterPortField('rate', val)}
                    value={this.props.data.get('rate') || ''}
                    disabled={this.props.disabled}
                  />
                </Col>
                <Col sm={5} style={{ padding: '0px 5px 0px 5px' }}>
                  <RefPicker
                    dict="loadingterm" name="term"
                    onChangeFunc={val =>
                      this.props.alterPortField('term',
                        val !== undefined && val !== null ? val.value : val)}
                    defaultValue={this.props.data.get('term')}
                    disabled={this.props.disabled}
                  />
                </Col>
                <Col sm={4} style={{ padding: '0px 5px 0px 5px' }}>
                  <FormControl
                    componentClass="select"
                    placeholder=""
                    name="termModificator"
                    onChange={(ev) => this.props.alterPortField('termModificator', ev.target.value)}
                    defaultValue={this.props.data.get('termModificator')}
                    disabled={this.props.disabled}
                  >
                    <option value="UU">UU</option>
                    <option value="EIU">EIU</option>
                  </FormControl>
                </Col>
              </Row>
            </Label>
          </Col>
          :
          <Col md={6}>
            <Label label="Detention" vertical sm={12} style={{ padding: '0px 5px 0px 5px' }}>
              <Row id="detentionCurrency">
                <Col sm={4}>
                  <CurrencyInput
                    noRates
                    name="detentionCurrency"
                    defaultValue={this.props.data.get('detentionCurrency')}
                    disabled={this.props.disabled}
                    onChange={(val) => this.props.alterPortField('detentionCurrency', val)}
                  />
                </Col>
                <Col sm={8}>
                  <FancyInput
                    className="form-control"
                    thousand
                    fraction={0}
                    positive
                    negative={false}
                    type="number"
                    id="detentionAmount" name="detentionAmount"
                    onChange={(ev, val) => this.props.alterPortField('detentionAmount', val)}
                    value={this.props.data.get('detentionAmount') || ''}
                    disabled={this.props.disabled}
                  />
                </Col>
              </Row>
            </Label>
          </Col>
        }
      </Row>
      {!this.state.CQD ?
        <Row>
          <Col md={6}>
            <Label label="Demurrage" vertical sm={12} style={{ padding: '0px 5px 0px 5px' }}>
              <Row id="demurrageCurrency">
                <Col sm={4} style={{ paddingRight: '0px' }}>
                  <CurrencyInput
                    noRates
                    name="demurrageCurrency"
                    defaultValue={this.props.data.get('demurrageCurrency')}
                    disabled={this.props.disabled}
                    onChange={(val) => this.props.alterPortField('demurrageCurrency', val)}
                  />
                </Col>
                <Col sm={8}>
                  <FancyInput
                    className="form-control"
                    thousand
                    fraction={0}
                    positive
                    negative={false}
                    type="number"
                    id="demurrageAmount" name="demurrageAmount"
                    onChange={(ev, val) => this.props.alterPortField('demurrageAmount', val)}
                    value={this.props.data.get('demurrageAmount') || ''}
                    disabled={this.props.disabled}
                  />
                </Col>
              </Row>
            </Label>
          </Col>
          <Col md={6}>
            <Label label="Dispatch" vertical sm={12} style={{ padding: '0px 5px 0px 5px' }}>
              <Row id="dispatchCurrency">
                <Col sm={4} style={{ paddingRight: '0px' }}>
                  <CurrencyInput
                    noRates
                    name="dispatchCurrency"
                    defaultValue={this.props.data.get('dispatchCurrency')}
                    disabled={this.props.disabled}
                    onChange={(val) => this.props.alterPortField('dispatchCurrency', val)}
                  />
                </Col>
                <Col sm={8} style={{ paddingRight: '13px' }}>
                  <FancyInput
                    className="form-control"
                    thousand
                    fraction={0}
                    positive
                    negative={false}
                    type="number"
                    id="dispatchAmount" name="dispatchAmount"
                    onChange={(ev, val) => this.props.alterPortField('dispatchAmount', val)}
                    value={this.props.data.get('dispatchAmount') || ''}
                    disabled={this.props.disabled}
                  />
                </Col>
              </Row>
            </Label>
          </Col>
        </Row>
        :
        <Row style={{ height: '76px' }} />
      }
      {/* Discharge/loading at underneath section */}
      <Row>
        <Col md={3}>
          <Label label="ETC" vertical sm={12} style={{ padding: '0px 5px 0px 5px' }}>
            <DateTimePicker
              format={dateTimePickerFormat}
              time={false}
              name="etc"
              onChange={val => {
                this.props.alterPortField('etc',
                  val ? moment(val).format('DD MMM YYYY') : undefined);
                this.props.handleFormChanged();
              }}
              defaultValue={this.props.data.get('etc')
                ? new Date(this.props.data.get('etc'))
                : undefined}
              disabled={this.props.disabled}
            />
          </Label>
        </Col>
        <Col md={3}>
          <Label
            label="Time"
            vertical
            sm={12}
            style={{ padding: '0px 5px 0px 5px' }}
          >
            <DateTimePicker
              step={15}
              timeFormat={timePickerFormat}
              format={timePickerFormat}
              date={false}
              time
              name="etcTime"
              parse={this.parseTime}
              onChange={val => this.props.alterPortField('etcTime',
                val ? moment(val).format(`${dateTimePickerFormat} ${timePickerFormat}`)
                  : undefined)}
              defaultValue={this.props.data.get('etcTime')
                ? new Date(this.props.data.get('etcTime'))
                : undefined}
              disabled={this.props.disabled}
            />
          </Label>
        </Col>
        {this.props.portType == 'vesselLoadingPorts'
          ?
          <Col md={6}>
            <Label
              label="Bill of lading date"
              vertical
              sm={12}
              style={{ padding: '0px 5px 0px 5px' }}
            >
              <DateTimePicker
                format={dateTimePickerFormat}
                time={false}
                name="billLandingDate"
                onChange={val => {
                  this.props.alterPortField('billLandingDate',
                    val ? moment(val).format('DD MMM YYYY') : undefined);
                  this.props.handleFormChanged();
                }}
                defaultValue={this.props.data.get('billLandingDate')
                  ? new Date(this.props.data.get('billLandingDate'))
                  : undefined}
                disabled={this.props.disabled}
              />
            </Label>
          </Col>
          : ''
        }
      </Row>
      <Row>
        <Col md={12}>
          <Label
            label="Comment" vertical sm={12} style={{ padding: '0px 5px 0px 5px' }}
          >
            <FormTextField
              name="comment"
              onChangeFunc={(val) => this.props.alterPortField('comment', val)}
              defaultValue={this.props.data.get('comment')}
              disabled={this.props.disabled}
            />
          </Label>
        </Col>
      </Row>
      <Row style={{ display: 'flex' }}>
        <Col md={6}>
          <Label
            label="Sailing date" vertical sm={12} style={{ padding: '0px 5px 0px 5px' }}
          >
            <DateTimePicker
              format={dateTimePickerFormat}
              time={false}
              name="sailingDate"
              onChange={val => {
                this.props.alterPortField('sailingDate',
                  val ? moment(val).format('DD MMM YYYY') : undefined);
                this.props.handleFormChanged();
              }}
              defaultValue={this.props.data.get('sailingDate')
                ? new Date(this.props.data.get('sailingDate'))
                : null}
              disabled={this.props.disabled}
            />
          </Label>
        </Col>
      </Row>
      <Row className={'port-edit-footer'}>
        <Col xs={12}>
          <Button
            bsStyle="link" style={{ float: 'left' }} onClick={this.openModal}
            id="deletePort"
          >
            {!this.props.disabled ?
              <div>
                {this.state.hidden
                  ? <Glyphicon glyph="repeat"> Restore</Glyphicon> :
                  <img className={'trash-icon'} src={trash} alt={'Delete'} title={'Delete'} />
                }
              </div>
              : ''
            }
          </Button>
          <AvailableSince version={VERSIONS.VasyaFinal}>
            <RoleConfigFilter permissions={['audit']}>
              <Audit
                group={{
                  deal: {
                    entity: this.props.transport,
                    module: 'transport',
                  },
                  loadingPorts: {
                    entities: this.props.loadingPorts,
                    module: 'port',
                    prefix: 'L',
                  },
                  dischargePorts: {
                    entities: this.props.dischargePorts,
                    module: 'port',
                    prefix: 'D',
                  },
                }}
                selectedEntityString={`port#${this.props.data.get('id')}`}
                title="Deal audit"
              >
                <img src={audit} className={'audit-icon'} alt={'Audit'} />
              </Audit>
            </RoleConfigFilter>
          </AvailableSince>
        </Col>
      </Row>
    </div>);
  }
}

PortEditClass.propTypes = {
  portType: React.PropTypes.string,
  data: React.PropTypes.object,
  formId: React.PropTypes.number,
  alterPort: React.PropTypes.func,
  alterPortField: React.PropTypes.func,
  handleFormChanged: React.PropTypes.func,
  disabled: React.PropTypes.bool,
  idx: React.PropTypes.number,
  transport: React.PropTypes.object,
  loadingPorts: React.PropTypes.object,
  dischargePorts: React.PropTypes.object,
};

export default connect(() => ({}), (dispatch, props) => ({
  alterPort(data) {
    alterPort(dispatch, props.portType, props.formId, data);
  },
  alterPortField(field, value) {
    alterPortField(dispatch, props.portType, props.formId, field, value);
  },
  handleFormChanged() {
    handleFormChanged(dispatch);
  },
}))(PortEditClass);
